import { useTranslation } from "react-i18next";
import Button from "../../components/ui/button/Button";
import CustomSearchField from "./CustomSearchField";
import styles from "./styles/Customization.module.css";

const CustomSearchGroup = ({
    groupType, // string - the type of the group (e.g. tickets)
    item, // object - the group object (e.g. customizations?.pos?.tickets.group)
    idx, // number - the index of the group
    customizations, // object - the customizations object
    deletePOSGroup, // function - delete the group
    handleNestedChange, // function - handle nested changes
    deleteField, // function - delete a field
    addField, // function - add a field
    categories, // array - the fields names array
}) => {
    const { t } = useTranslation();
    return (
        <div
            className={`${styles.input_container}  ${styles.links_container} ${styles.POS_group_container} v-flex-container`}
        >
            {/* The delete group bytton */}
            <div className={`${styles.delete_group_button}`}>
                <Button
                    body={t(`delete`)}
                    size={"small"}
                    type={"button"}
                    backgroundColor={"red"}
                    onClickFuction={() => deletePOSGroup(groupType, item?.id)}
                />
            </div>

            <h3 className={`${styles.sub_header_group}`}>
                {t(`search group`)} {idx + 1}
            </h3>
            {/* The search fields in the group */}
            {item?.fields.map((field, idx2) => (
                <CustomSearchField
                    key={`${groupType}-${idx}F${idx2}`}
                    groupType={groupType}
                    item={item}
                    field={field}
                    idx={idx} // The group index
                    idx2={idx2} // The field index
                    handleNestedChange={handleNestedChange}
                    deleteField={deleteField}
                    categories={categories}
                    customizations={customizations}
                />
            ))}
            {/* Add field button */}
            <div className={`${styles.add_field_button}`}>
                <Button
                    body={t(`add category`)}
                    size={"small"}
                    type={"button"}
                    onClickFuction={() => addField(groupType, idx)}
                />
            </div>
        </div>
    );
};

export default CustomSearchGroup;
